import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Validators, FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from 'ng-formly';
import { Urls } from '../urls';
import { PlaceholderFieldsService } from '../placeholder-fields.service';
import { Response } from '../response';
@Component({
  selector: 'app-throwaway',
  templateUrl: './throwaway.component.html',
  styleUrls: ['./throwaway.component.css']
})
export class ThrowawayComponent implements OnInit {

  constructor(private http: HttpClient,private urls : Urls, private pFields : PlaceholderFieldsService) { }

   form = new FormGroup({});
   forms=[];
   fields = [];

   response ="";
   model = {};
  service = "";
   method = "";
   fMethod = "";
   fService = "";
   isProd = false;
   methodType = "";
   curlModel = {'service':'','method':'','methodType':'','viewModel':{},'fMethod':'','fService':''};
  ngOnInit() : void {
    this.fields = this.pFields.get();
    
    this.service = "";
    this.method = "";
    this.methodType = "";
  }
  get() : void 
  {
    if(this.fMethod == "")
    {
      return;
    }
    if(this.fService == "")
    {
      return;
    }
    this.http.get<Response>("http://frontierlink.loc/api/Admin/General/fields?method="+ this.fMethod +"&service=" + this.fService).subscribe(data =>{
      this.fields = data.data;
      this.curlModel = {'service':'','method':'','methodType':'','viewModel':{},'fMethod':'','fService':''};
    });
  }
  set() : void 
  { 

    var viewModel = {'viewModel' : this.model,"service":this.curlModel.service,"method":this.curlModel.method,"methodType":this.curlModel.methodType,};
    this.curlModel.fMethod = this.fMethod;
    this.curlModel.fService = this.fService;
    this.http.post<Response>(this.getUrl(),this.curlModel).subscribe(data=>{
       this.response = data.data;
    });
  }
  getUrl() : string
  {
    if(this.isProd)
    {
      return "http://app.atu.net.au/api/Admin/General/call";
    }
    return "http://frontierlink.loc/api/Admin/General/call"
  }
  showUrl()
  {
    console.log("Server url is "+this.getUrl());
  }


}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/throwaway/throwaway.component.ts